import { render, staticRenderFns } from "./WannasornUserManagementPage.vue?vue&type=template&id=44a5047a&scoped=true"
import script from "./WannasornUserManagementPage.vue?vue&type=script&lang=js"
export * from "./WannasornUserManagementPage.vue?vue&type=script&lang=js"
import style0 from "./WannasornUserManagementPage.vue?vue&type=style&index=0&id=44a5047a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a5047a",
  null
  
)

export default component.exports